// Definición de permisos por servicio
export const table = {

    // nombre tablas principales
    role: 'role',
    user: 'user',
    prov: 'prov',
    docu: 'docu',
    prod: 'prod',
    item: 'item',
    ocar: 'ocar',
    facturas: 'facturas',
    accesodte: 'accesodte',
    sopa: 'sopa',
    avio: 'avio',
    autos: 'carx',
    pac: 'paxx',
    file: 'file',
    ocarOldr: 'ocarOldr',
    docuOldr: 'docuOldr',
    sopaOldr: 'sopaOldr',
    inic:'inic',
    inicOldr:'inicOldr',

    // nombre tablas segundarias
    docMeta: "docuMeta",
    provMeta: "provMeta",
    prodMeta: "prodMeta",
    itemMeta: "itemMeta",
    ocarMeta: "ocarMeta",
    sopaMeta: "sopaMeta",
    avioMeta: "avioMeta",
    autosMeta: "carxMeta",
    pacMeta: "paxxMeta",
    userMeta: "userMeta",
    roleMeta: "roleMeta",
    initMeta: 'inicMeta',

    // opciones de consulta
    type: {
        extn: 'extn',
        meta: 'meta',
        metaExtn: 'metaExtn',
        toOld: 'toOldr',
        toNew: 'toNew'
    }

}
